import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { SocialIcon } from 'react-social-icons'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import "../index.css";

import Footer from "./Footer";
import config from "../config/index.json";
import { Link, useNavigate } from "react-router-dom";

import Header from "./Header";
import SimpleHeader from "./SimpleHeader";

type AuthorItem = {
  fields: {
    fullName: string;
    role: string;
    pirofilePicture: object;
  };
  metadata: any;
  sys: any;
}

type AuthorState = {
  item: AuthorItem;
  profilePicture: string;
};

type NewsState = {
  item: any;
  coverImage: string;
}

function NewsList() {
  const navigate = useNavigate()
  const [ id, setId ] = useState('') 
  const { images } = config;
  const { logo } = images;

  const [ totalNews, setTotalNews ] = useState<any>([])

  const CONTENTFUL_SPACE_ID = "qitjy5hyl5up"
  const CONTENTFUL_ACCESS_TOKEN = "TKo1zCQL_v1NQmGcRQXQVqayvDSqukrdCeRlbpEedyM"

  const contentfulEndpointNews = `https://cdn.contentful.com/spaces/${CONTENTFUL_SPACE_ID}/environments/master/entries?access_token=${CONTENTFUL_ACCESS_TOKEN}&content_type=news`;


  useEffect(()=>{
    (async () => {
      try {
        const res = await fetch(contentfulEndpointNews);
        const data = await res.json();
        console.log('newsdata', data)
        setTotalNews(data);
      } catch (error) {
        console.log(error);
      }
    })();

  },[])

  const handleSelectNews = (nid:string) => {
    console.log('nid',nid)
    navigate('/news', {state: {nid:nid}})
  }

  const handleMouseEnter = () => {
    const bgHeader = document.querySelector('#hero');
    if (bgHeader) {
      bgHeader.classList.replace('brightness-100', 'brightness-50')
    }
  }

  const handleMouseLeave = () => {
    const bgHeader = document.querySelector('#hero');
    if (bgHeader) {
      bgHeader.classList.replace('brightness-50', 'brightness-100')
    }
  }

  return (
    <>
      <section
        id="hero"
        style={{backgroundImage:`url(${totalNews?.includes?.Asset?.length>0?(totalNews?.includes?.Asset[2]?.fields.file.url):''})`}}
        className="brightness-100 bg-no-repeat w-full bg-center bg-cover pt-80 pb-6 h-[40vh]"
      >
        <div
          id="header"
          className="absolute w-full top-0 z-20 pt-4 md:pt-16 pb-4 px-4 md:px-16"
        >
          {/* <div className="flex justify-center md:justify-between flex-col-reverse	md:flex-row">
            <div className="flex items-left md:items-center">
              <img
                src={logo}
                className="mt-16 md:my-4 w-40 block mr-auto ml-0 md:mx-auto"
                alt="logo"
              />
            </div>
          </div> */}
        </div>
      </section>
      <SimpleHeader/>
      <section>
        <div className="pb-[250px]">
          <div className="grid grid-cols-1 md:grid-cols-3">
            <div className="col-span-1 pt-10 pl-10 ">
                <h1 className="text-[#0c2957] text-[2rem] font-bold mb-10 ms-8">News</h1>
                <div className="bg-[#e0f9fd] w-full pt-12 pb-10 pl-10 pr-16">
                    <h1 className="w-[200px] text-3xl text-[#0c2957] font-bold mb-6">
                        Iscriviti alla newsletter
                    </h1>
                    <p className="text-lg font-semibold">
                        Iscriviti per ricevere periodicamente notizie e aggiornamenti sul mondo 
                        di Italy HLG, incluse le nostre iniziative in anteprima, i nostri eventi 
                        e quello che nella nostra industria ci ispira e ci guida. Iscrivendoti 
                        accetti <span>questi termini.</span>
                    </p>
                    <form className="w-4/5 mb-10" action="">
                        <input className="w-full h-[60x] bg-[#e5f8fc] text-md py-7 border-b-[2px]" type="email" placeholder="Your email" />
                        <button className="bg-[#0c2957] text-xs font-bold  w-full py-7 text-white tracking-widest">INVIA</button>
                    </form>
                </div>
            </div>
            <div className="col-span-2 ">
              <div className=" z-50 bg-white pt-[55px] pl-[120px] pr-40">
              {totalNews?.items?.map((news:any)=>{
                    return(
                        <div onClick={()=>handleSelectNews(news?.sys.id)} className="mb-20 cursor-pointer">
                            <h3 className="text-[#27b4a5] text-xs pb-2">{news?.fields.date}</h3>
                            <h1 className="text-[2rem] text-[#0c2957] leading-[3rem] hover:underline mb-6">{news?.fields.title}</h1>
                            <p className="text-lg font-[600] mb-4">Sono già aperte sulla piattaforma dedicata le iscrizioni al Summer Meeting Italy HLG, durante il quale avrà luogo anche l'Assemblea dei soci.</p>
                            <h3 className="text-[#27b4a5] hover:underline font-[600]">Leggi di più</h3>
                        </div>
                    )
                })     
              } 
              </div>
            </div>
          </div>
        </div>

      </section>
      <Footer></Footer>
    </>
  );
}

export default NewsList;
